import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import DeviceRegistrationModal from '@shared/components/DeviceRegistrationModal';
import { useRegistrationStatus } from '@shared/hooks/useRegistrationStatus';

interface Props {
  children: React.ReactNode;
}

/**
 * Gates the app based on health API registration status.
 * - Loading: empty screen
 * - Error: error message with retry
 * - Not registered (vessel null/empty): shows blocking registration modal
 * - Registered: renders children
 */
export function DeviceGate({ children }: Props) {
  const { isRegistered, isLoading, isError, refetch } = useRegistrationStatus();

  if (isLoading) return null;

  if (isError) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 2,
        }}
      >
        <Typography variant="body1" color="text.secondary">
          Could not connect to the server.
        </Typography>
        <Button variant="outlined" onClick={() => void refetch()}>
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <>
      <DeviceRegistrationModal open={!isRegistered} onRegistered={() => {}} />
      {isRegistered && children}
    </>
  );
}
